import { useContext } from 'react';
import usePageType from './use-page-type';
import { bookingState } from '../Pages/Booking/client-state/booking-state-context';
import { giftcardState } from '../Pages/Giftcard/client-state/giftcard-state-context';
import { bookingEditState } from '../Pages/BookingEdit/client-state/booking-edit-state-context';
import { membershipState } from '../Pages/Membership/client-state/membership-state-context';

const useClientState = () => {
  const { state: stateBooking, dispatch: dispatchBooking } = useContext(bookingState);
  const { state: stateBookingEdit, dispatch: dispatchBookingEdit } =
    useContext(bookingEditState);
  const { state: stateGiftcard, dispatch: dispatchGiftcard } = useContext(giftcardState);
  const { state: stateMembership, dispatch: dispatchMembership } =
    useContext(membershipState);

  const pageType = usePageType();

  switch (pageType) {
    case 'booking': {
      return { state: stateBooking, dispatch: dispatchBooking };
    }
    case 'edit-booking': {
      return { state: stateBookingEdit, dispatch: dispatchBookingEdit };
    }
    case 'giftcard': {
      return { state: stateGiftcard, dispatch: dispatchGiftcard };
    }
    case 'membership': {
      return { state: stateMembership, dispatch: dispatchMembership };
    }
    default: {
      return { state: stateBooking, dispatch: dispatchBooking };
    }
  }
};

export default useClientState;
